interface WithId {
  id: number;
  [key: string]: any;
}

/** Reorders arrayOfObjects that have id field to match ids order */
export const reorderByIds = <T extends WithId>(arrayOfObjects: T[], ids: number[]): T[] => ids.map(id => arrayOfObjects.find(obj => obj.id === id))